import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { CoreService } from 'src/app/core/helpers/core.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { GaService } from 'src/app/core/helpers/ga.service';

@Component({
  selector: 'loyaltic-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  email: any;
  password: any;
  confirmPassword: any;
  IsAcceptTerms: any;
  isMarketingPermission: any;
  isEmailPermission: any;
  firstName: any;
  lastName: any;
  isFazerRegistered: any;

  constructor(private coreService: CoreService,
    private authService: AuthService, private router: Router,
    private toast: ToastrService, private translate: TranslateService, private gaService: GaService) { }

  ngOnInit() {
  }

  onSubmit(formRef) {
    if (this.password !== this.confirmPassword) {
      return;
    }
    
    const body = {
      Email: this.email,
      Password: this.password,
      IsAcceptTerms: this.IsAcceptTerms,
      IsMarkettingPermission: this.isMarketingPermission,
      IsEmailPermission: this.isEmailPermission,
      FirstName: this.firstName,
      LastName: this.lastName,
    };
    if (formRef.valid){
      this.coreService.register(body).then((registerResponse: any) => {
        localStorage.setItem("email", this.email);
        formRef.submitted = false;
        this.resetForm();
        this.gaService.emitEvent('Registration', 'success');
        localStorage.setItem("firstName",registerResponse.result.firstName);
        const successMessage = this.translate.instant(registerResponse.messageKey);
        this.toast.success(successMessage, ' ');
        this.authService.setToken(registerResponse.result.token, registerResponse.result.id);
        this.router.navigate(['']);
      }).catch((errorResponse: any) => {
        const errorMessage = this.translate.instant(errorResponse.error.messageKey);
        this.resetForm();
        this.toast.error(errorMessage, ' ');
        return;
      });
    }

  }

  resetForm() {
    this.email = undefined;
    this.password = undefined;
    this.confirmPassword = undefined;
    this.isMarketingPermission = undefined;
  }



}
